import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { ISiteAnnouncement } from './models/site-announcement.interface';
import { UtilityService } from '../../services/utility/utility.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { SiteAnnouncementDialogComponent } from './site-announcement-dialog/site-announcement-dialog.component';

@Component({
  selector: 'upsc-site-announcement',
  templateUrl: './site-announcement.component.html',
  styleUrls: ['./site-announcement.component.scss'],
})
export class SiteAnnouncementComponent implements OnInit, OnChanges {
  @Input() siteAnnouncement: ISiteAnnouncement;
  @Output() siteAnnouncementClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  public shouldDisplaySiteAnnouncement = false;
  public shouldDisplaySiteAnnouncementLink = false;

  constructor(private utilityService: UtilityService,
              private dialog: MatDialog) {
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.onSiteAnnouncementChanged(changes['siteAnnouncement']);
  }

  private onSiteAnnouncementChanged(change: SimpleChange) {
    if (!change) {
      return;
    }

    const siteAnnouncementValue: ISiteAnnouncement = change.currentValue;
    this.shouldDisplaySiteAnnouncement = !!siteAnnouncementValue;
    this.shouldDisplaySiteAnnouncementLink = siteAnnouncementValue && siteAnnouncementValue.Type !== 0;
  }

  public getTruncatedHeadMessage(): string {
    if (!this.siteAnnouncement || !this.siteAnnouncement.Header) {
      return;
    }

    return this.utilityService.truncateText(this.siteAnnouncement.Header, 120);
  }

  public showDetails() {
    if (!this.siteAnnouncement) {
      return;
    }

    switch (this.siteAnnouncement.Type) {
      case 1:
        this.handleMessageDialog();
        break;
      case 2:
        if (!this.siteAnnouncement.Hyperlink) {
          return;
        }

        window.open(this.siteAnnouncement.Hyperlink);
        break;
      default:
        break;
    }
  }

  private handleMessageDialog() {
    const dialogConfig: MatDialogConfig = {
      data: {
        message: this.siteAnnouncement.Message,
      },
    };
    const dialogRef: MatDialogRef<SiteAnnouncementDialogComponent> = this.dialog.open(SiteAnnouncementDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
        (result) => {
        });
  }

  public closeAnnouncement() {
    this.shouldDisplaySiteAnnouncement = false;
    this.siteAnnouncementClosed.emit(true);
  }
}
